import React, { Component } from "react";
import { Container } from "reactstrap";
import { Redirect } from "react-router-dom";
import "./NavMenu.css";
import "./Main.css";
import Menu, { SubMenu, MenuItem } from "rc-menu";
import "rc-menu/assets/index.css";
import { withStyles } from "@material-ui/core";
import { isNullOrEmpty, getCookie } from "./Util";

export var styles = function styles(theme) {
	return {
		menuRoot: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			height: "100%",
			display: "flex",
			flexDirection: "column",
		},
		container: {
			flex: "0 0 180px",
			backgroundColor: "white",
			marginRight: "4px",
			padding: "0px",
		},
		menuItem: {
			textAlign: "center",
			cursor: "pointer",
			"&:hover, & div:hover": {
				backgroundColor: theme.palette.primary.dark,
				transition: "0.3s",
			},
		},
		menuItemSelected: {
			backgroundColor: theme.palette.primary.dark,
		},
		logo: {
			fontWeight: 700,
			whiteSpace: "pre-wrap",
			fontSize: "18px",
		},
	};
};

class NavMenu extends Component {
	static displayName = NavMenu.name;

	constructor(props) {
		super(props);
		this.toggleNavbar = this.toggleNavbar.bind(this);
		this.state = {
			collapsed: true,
			activeElement: "Dashboard",
			dropdownVisible: false,
			dropdownItem: "",
			activeNav: null,
			role: getCookie("role"),

			navItems: [
				{ display: "Dynamic Elevator Control", route: "/dashboard/" },
				{ display: "Dashboard", route: "/dashboard" },
				{
					display: "Client Portal",
					route: "/clientportal",
					subMenus: [
						{ display: "Tickets", route: "/tickets" },
						{ display: "Invoices", route: "/invoices" },
						{ display: "Estimates", route: "/proposals" },
						{ display: "Inspection Reports", route: "/inspection" },
					],
				},
			],
		};

		this.navigate = this.navigate.bind(this);

		if (this.state.role === "Admin")
			this.state.navItems.push(
				{
					display: "All Tickets",
					route: "/ticketingportal",
					subMenus: [
						{ display: "All Tickets", route: "/alltickets" },
						{ display: "Recommendation", route: "/recommendation" },
						{ display: "Sales Ticket", route: "/salesticket" },
						{ display: "Out of Service", route: "/outofservice" },
					],
				},
				{
					display: "Buildings",
					route: "/buildings",
					subMenus: [
						{ display: "Tickets", route: "/tickets" },
						{ display: "Elevators", route: "/elevators" },
						{ display: "Notes", route: "/notes" },
						{ display: "Contacts", route: "/contacts" },
						{ display: "Inspection Reports", route: "/inspection" },
					],
				},
				{ display: "Users", route: "/usersetup" },
				{ display: "Estimates", route: "/proposaladmin" },
				{ display: "Approved Packing Lists", route: "/packinglistapproved" },
				{ display: "Unapproved Packing Lists", route: "/packinglistunapproved" },
				{ display: "Support", route: "/support" },
				{ display: "Checked-In Mechanics", route: "/checkedin" },
				{ display: "Inspections", route: "/inspections" },
				{ display: "Alterations", route: "/alterations" },
				{ display: "Broken Elevators", route: "/brokenelevators" },
				{ display: "Follow Ups", route: "/followups" }
			);
	}

	navigate(item, route, x) {
		var r = item.key === "/" ? "/dashboard" : item.key;

		if (r === "collapse") {
			this.toggleNavbar();
		} else {
			var menu = this.state.navItems.filter((item) => item.route === r)[0];
			if (menu && menu.subMenus) {
				r += menu.subMenus[0].route;
			}
			r += (r.endsWith("/") ? "" : "/") + Math.random();
			this.setState({ activeNav: r });
		}
	}

	toggleNavbar() {
		this.setState({
			collapsed: !this.state.collapsed,
		});
	}
	render() {
		return (
			<Container className={this.props.classes.container}>
				<Menu color="primary" mode="vertical" onClick={this.navigate} className={[this.props.classes.menuRoot]} selectedKeys={[document.location.pathname.split("/")[1] ? "/" + document.location.pathname.split("/")[1] : "/dashboard"]}>
					{this.state.navItems.map((item, idx) => {
						var classes = [this.props.classes.menuItem];
						if (item.route === "/") {
							classes.push(this.props.classes.logo);
						} else if (document.location.pathname.includes(item.route) || ((isNullOrEmpty(document.location.pathname) || document.location.pathname === "/") && item.route === "/dashboard")) {
							classes.push(this.props.classes.menuItemSelected);
							classes.push("shadow");
						}

						if (item.subMenus && item.subMenus.length > 0) {
							return (
								<SubMenu title={item.display} className={classes.join(" ")} active={(document.location.pathname.indexOf(item.route) > -1).toString()} key={item.route} onClick={this.navigate} onTitleClick={this.navigate}>
									{item.subMenus.map((subItem) => {
										return <MenuItem key={item.route + subItem.route}>{subItem.display}</MenuItem>;
									})}
								</SubMenu>
							);
						}

						return (
							<MenuItem className={[classes]} key={item.route}>
								{item.display}
							</MenuItem>
						);
					})}
					<MenuItem className={[this.props.classes.menuItem]} style={{ marginTop: "auto" }} key={"/logout"}>
						Logout
					</MenuItem>
				</Menu>
				{this.state.activeNav && <Redirect push to={this.state.activeNav}></Redirect>}
			</Container>
		);
	}
}

export default withStyles(styles, { withTheme: true })(NavMenu);
